import * as axiosHelper from "./api_helper";
import qs from "qs";

export const getReminders = async ({ payload }) => {
  const data = await axiosHelper.get(`/reminders?${qs.stringify(payload)}`);
  if (data.isError) {
    throw new Error(data.isError);
  }
  return data.result;
};

export const addReminder = async (params) => {
  const { id, ...obj } = params;
  let data;
  if (id) {
    data = await axiosHelper.patch(`/reminders/${id}`, obj);
  } else {
    data = await axiosHelper.post("/reminders", obj);
  }
  if (data.isError) {
    throw new Error(data.message);
  }
  return data.result;
};

export const editReminder = async (params) => {
  const id = params.id;
  const copyParams = { ...params };
  delete copyParams.id;
  const data = await axiosHelper.patch(`/reminders/${id}`, copyParams);
  if (data.isError) {
    throw new Error(data.message);
  }
  return data.result;
};

export const deleteReminder = async (payload) => {
  const data = await axiosHelper.del(`/reminders/${payload.id}`);
  if (data.isError) {
    throw new Error(data.message);
  }
  return data.result;
};
